import { useQuery } from '@tanstack/react-query';

import type { DomainListShopSaleTaskSummariesResponse } from '@/Swagger';
import axiosInstance from '@/axios/axios';
import type { UseAxiosQueryOptions } from '@/utils/typeHelper';

type QueryOptions = UseAxiosQueryOptions<
  DomainListShopSaleTaskSummariesResponse,
  ['saleTaskSummaries', { shopID: string }]
>;
/**
 * 샵의 판매관리 태스크 진행사항 요약 리스트를 조회하는 API
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Sales/get_shops__shopID__sale_task_summaries
 */
export const useGetSaleTaskSummaries = ({ shopID, options }: { shopID?: string; options?: Partial<QueryOptions> }) =>
  useQuery({
    queryKey: ['saleTaskSummaries', { shopID: shopID ?? ' ' }],

    queryFn: () =>
      axiosInstance
        .get<DomainListShopSaleTaskSummariesResponse>(`/shops/${shopID}/sale-task-summaries`)
        .then(v => v.data),

    ...options,
  });
